import { useTranslation } from "react-i18next";
import { Button, Flex } from "antd";

import AuthCard from "../../components/auth/AuthCard";
import { usePageTitle } from "../../utils/usePageTitle";

export const ExistingYandexEmailPage = () => {
  const { t } = useTranslation();
  usePageTitle(t("existingYandexEmail.title"));

  return (
    <AuthCard>
      <h1>{t("existingYandexEmail.title")}</h1>
      <p>{t("existingYandexEmail.description")}</p>
      <Flex gap={8} style={{ marginTop: 8 }} wrap>
        <Button type="primary" size="large" href="/login/1">
          {t("signin.buttonText")}
        </Button>
        <Button size="large" href="/yandex/login/">
          {t("existingYandexEmail.chooseAnother")}
        </Button>
      </Flex>
    </AuthCard>
  );
};
